import { Injectable } from "@angular/core";
import { ApiHttpClient } from "../modules/tcm-core.module";
import { NotificationFormResponse } from "../models/notifications/notification-form-response";
import { NotificationFormRequest, NotificationGetFormRequest } from "../models/notifications";

@Injectable({
  providedIn: "root",
})
export class NotificationDataService {
  constructor(private readonly httpClient: ApiHttpClient) {}

  getNotifications(request: NotificationGetFormRequest,timeout: Promise<any>): Promise<NotificationFormResponse> {
    return this.httpClient.postJsonAsync<NotificationFormResponse>("Notification/GetNotifications", request, timeout, false);
  }

  markAsRead(
    markAll: boolean,
    id: number,
    userId: number,
    timeout: Promise<any>
  ) {
    const request = {
      markAll: markAll,
      userNotificationId: id,
      userId: userId,
    } as NotificationFormRequest;
    return this.httpClient.postJsonAsync(
      "Notification/MarkAsRead",
      request,
      timeout,
      false
    );
  }
  deleteNotification(
    markAll: boolean,
    id: number,
    userId: number,
    timeout: Promise<any>
  ) {
    const request = {
      markAll: markAll,
      userNotificationId: id,
      userId: userId,
    } as NotificationFormRequest;
    return this.httpClient.postJsonAsync(
      "Notification/DeleteNotification",
      request,
      timeout,
      false
    );
  }
}
